/* eslint-env browser */
import React, { useEffect, useRef, FC } from 'react';
import { setSubNavToggle } from '@aarhus-university/au-designsystem-delphinus/source/js/components/nav';

type Props = {
  children: JSX.Element;
  className: string;
  dataIcon: string;
  text: string;
  ariaLabel: string;
  id: string;
};

const AUSubNavComponent: FC<Props> = ({
  children,
  className,
  dataIcon,
  text,
  ariaLabel,
  id,
}) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    const subNavBtns = document.querySelectorAll('.sub-nav > button.nav__item');
    const {
      element,
      bodyClickEvent,
      buttonClickEvent,
    } = setSubNavToggle(subNavBtns, buttonRef.current as Element);
    return () => {
      if (element) {
        element.removeEventListener('click', bodyClickEvent);
      }
      buttonRef.current?.removeEventListener('click', buttonClickEvent);
    };
  }, []);

  return (
    <div className="sub-nav">
      <button
        ref={buttonRef}
        id={id}
        type="button"
        className={className}
        data-icon={dataIcon}
        aria-label={ariaLabel}
        aria-expanded={false}
      >
        {text}
      </button>
      {children}
    </div>
  );
};

AUSubNavComponent.displayName = 'AUSubNavComponent';
export default AUSubNavComponent;
